import OffersFacets from './OffersFacets'
import OffersFilter from './OffersFilter'

export default class OffersResponse {
  static empty () {
    return new OffersResponse({})
  }

  constructor ({ total = 0, results = [], facets = OffersFacets.empty(), filter = OffersFilter.empty() }) {
    this.total = total
    this.results = results
    this.facets = facets
    this.filter = filter
  }
}
